import { render, staticRenderFns } from "./IconHeading.vue?vue&type=template&id=7348d303&lang=pug&"
import script from "./IconHeading.vue?vue&type=script&lang=ts&"
export * from "./IconHeading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports